export function scopeData<T, K extends keyof T>(data: T[], userId: string, scopeKey: K): T[] {
  return data.filter((item: T) => item[scopeKey] === userId)
}
